<template>
  <div class="transfer-assign">
    <!-- 转移并分配 -->
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.transferAndAllocate')"></NavHeaderBar>
    <div class="info-section">
      <!-- 将门店转移至「维护组」，并为其分配一名负责人。 -->
      <div>{{ $t('shared.titleTwentyNine') }}.</div>
      <div class="form-item">
        <div class="label">{{ $t('form.assignedBaBd') }}</div>
        <XuSelect v-model="dutyId" :fieldNames="{label: 'nickName', value: 'id'}" :dataOptions="globalData.userOptions" />
      </div>
      <!-- 一旦转移成功不可恢复，请确定该门店是否已上架产品。 -->
      <div class="desc-tip">{{ $t('shared.titleThirty') }}.</div>
    </div>
    <div class="assign-btn">
      <van-button class="cancel-btn" @click="handleOper('cancel')">{{ $t('button.cancel') }}</van-button>
      <van-button class="confirm-btn" :loading="isLoading" loading-text="Confirm" @click="handleOper('confirm')">{{ $t('button.confirm') }}</van-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Dialog, Notify, Toast } from 'vant'
import { customerAllotDutyApi } from '@/api/unassignedStore'
export default {
  components: {
    XuSelect: () => import('@/components/XuSelect')
  },
  data () {
    return {
      dutyId: '',
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    })
  },
  activated () {
    this.dutyId = ''
  },
  methods: {
    handleOper (type) {
      if (type === 'confirm') {
        this.isLoading = true
        Dialog.confirm({
          // 确认转移该门店并分配给指定负责人吗？
          message: this.$t('tips.messageFortyNine'),
          confirmButtonText: this.$t('button.confirm'),
          cancelButtonText: this.$t('button.cancel'),
          confirmButtonColor: '#323233'
        })
          .then(() => {
            Toast.loading({
              message: this.$t('shared.loading'),
              forbidClick: true,
              duration: 0
            })
            customerAllotDutyApi({ id: this.$route.query.assignId, dutyId: this.dutyId }).then(res => {
              Toast.clear()
              Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
              this.isLoading = false
              this.$router.go(-1)
            }).catch(() => {
              this.isLoading = false
            })
          })
          .catch(() => {
          // on cancel
            this.isLoading = false
          })
      } else if (type === 'cancel') {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.transfer-assign {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f5f5f9;
  .info-section {
    flex: 1;
    padding: 10px;
    margin-top: 6px;
    margin-bottom: 10px;
    overflow-y: auto;
    background-color: #fff;
    .form-item {
      display: flex;
      align-items: center;
      margin: 10px 0;
      .label {
        width: 160px;
      }
    }
    .desc-tip {
      color: #c4200b;
      font-size: 10px;
    }
  }
  .assign-btn {
    display: flex;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    .cancel-btn,
    .confirm-btn {
      flex: 1;
      border: none;
      font-weight: bold;
    }
    .confirm-btn {
      background-color: #307bff;
      color: #fff;
    }
    .cancel-btn {
      color: #307bff;
    }
  }
}
</style>
